import PropTypes from "prop-types";
import styles from "./TextOverflowFade.css";

const TextOverflowFade = ({ text, ElementType = "p" }) => (
  <div className={styles.overflowFade}>
    <div>
      <ElementType>{text}</ElementType>
    </div>
  </div>
);

TextOverflowFade.propTypes = {
  text: PropTypes.string.isRequired,
  ElementType: PropTypes.string
};

export default TextOverflowFade;
